import { Alert, AlertIcon, AlertTitle, AlertDescription, CloseButton, Box, HStack, VStack } from "@chakra-ui/react";
import { useState } from "react";
import {
  AlertComponentProps
} from "@/types";

export function AlertComponent({ status, title, description, isClosable = true }: AlertComponentProps) {
  
  const [showAlert, setShowAlert] = useState(true);

  if (!showAlert) return null;

  return (
    <Box my={4}>
      <Alert status={status} borderRadius={8}>
        <VStack gap={1}>
          <HStack justify="center">
            <AlertIcon 
              mr={0}
            />
            {title && (
              <AlertTitle mr={2}>{title}</AlertTitle>
            )}
          </HStack>
          {description && (
            <AlertDescription>{description}</AlertDescription>
          )}
        </VStack>
        {isClosable && <CloseButton position="absolute" right="8px" top="8px" onClick={() => setShowAlert(false)} />}
      </Alert>
    </Box>
  );
}
